import { HttpStatusCode } from 'axios';
import apiFetcher from '../interCeptor';

export async function CreateSpecialOffer({ data }) {
    try {
        const response = await apiFetcher.post(`api/v1/store/special_offer`, data);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
}

export async function UpdateSpecialOffer({ id, data }) {
    try {
        const response = await apiFetcher.patch(`api/v1/store/special_offer/${id}`, data);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
}

export async function CreateCampaignOffer({ data }) {
    try {
        const response = await apiFetcher.post(`api/v1/store/campaign`, data);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
}

export async function UpdateCampaignOffer({ id, data }) {
    try {
        const response = await apiFetcher.patch(`api/v1/store/campaign/${id}`, data);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
}
